import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export class InputSystem {
  private _scene: Game = Game.current;
  private _isPointerDown = false;
  private _lastTapX = 0;
  private _lastTapY = 0;

  constructor() {
    this._scene.input.on('pointerdown', this._onPointerDown, this);
    this._scene.input.on('pointerup', this._onPointerUp, this);
  }

  public getMousePosition() {
    this._scene.input.activePointer.updateWorldPoint(this._scene.cameras.main);
    const pointer = this._scene.input.activePointer;
    return { x: pointer.worldX, y: pointer.worldY };
  }

  public getAttackPosition() {
    if (!this._isPointerDown) return null;
    return this.getMousePosition();
  }

  public getLastTapPosition() {
    return { x: this._lastTapX, y: this._lastTapY };
  }

  private _onPointerDown() {
    this._isPointerDown = true;

    const { x, y } = this.getMousePosition();
    this._lastTapX = x;
    this._lastTapY = y;

    this._showTapRipple(x, y);

    const gridPos = this._scene.getGridPos(x, y);

    if (this._scene.abilitySystem.needsAbilityTarget) {
      this._scene.abilitySystem.onClick(x, y);
      return;
    }

    this._scene.multiplayerSystem.startShooting(gridPos);
  }

  private _onPointerUp() {
    this._isPointerDown = false;

    if (this._scene.abilitySystem.needsAbilityTarget) {
      const { x, y } = this.getMousePosition();
      this._scene.abilitySystem.onClick(x, y);
      return;
    }

    this._scene.multiplayerSystem.stopShooting();
  }

  private _showTapRipple(x: number, y: number) {
    const ring = this._scene.add.graphics().setDepth(DEPTH.IMPACT + 1);

    this._scene.tweens.addCounter({
      from: 0,
      to: 1,
      duration: 220,
      ease: 'Cubic.out',
      onUpdate: (t) => {
        const p = t.getValue()!;
        ring.clear();
        ring.lineStyle(1.5 * (1 - p), 0xFFFF44, (1 - p) * 0.8);
        ring.strokeCircle(x, y, p * 22);
      },
      onComplete: () => ring.destroy(),
    });
  }
}
